import React from 'react';
import { motion } from 'framer-motion';
export function StorySection() {
  return <section className="px-6 py-32 md:py-40 bg-white text-black pt-[10px] pb-[10px]" data-id="element-95">
      <div className="w-full max-w-3xl mx-auto text-center" data-id="element-96">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-3xl text-gray-500 font-light leading-relaxed mb-16" data-id="element-97"></motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-black text-white p-10 md:p-16 rounded-[2rem] text-center shadow-2xl" data-id="element-98">
          <p className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight" data-id="element-99">
            “En el rubro del tatuaje, esto todavía está crudo.”
          </p>
        </motion.div>
      </div>
    </section>;
}